import React, { useContext, useEffect, useState } from "react"
import Form from "../components/Forms/Form"
import Header from "../components/Header"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"
import { Context } from "../store/store"
import ReceiptUpload from "../components/receipt/ReceiptUpload"
import NextStep from "../components/elements/NextStep"
import Popup from "../components/elements/Popup"

const Home: React.FC = () => {
	const { dispatch } = useContext(Context)

	const [showPopup, setShowPopup] = useState<boolean>(false)
	useEffect(() => {
		if (process.env.NODE_ENV === "production") {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth",
			})
		}
	}, [])
	return (
		<PromoSoonOverHandler>
			<div className="relative bg-white">
				<Header />
				<p className="w-full px-4 text-center font-CalibriRegular text-[12px] md:pl-[10%] md:w-[55%] md:text-left md:text-[18px] pb-[18px] md:pb-[48px] mt-6 md:-mt-4 relative  z-10">
					Aktionszeitraum vom 25.05. bis 05.07.2026. <br className="block sm:hidden" />
					Teilnahme ab 18 Jahren. <br className="block sm:hidden" />
					Die Gewinner werden in den ersten zwei Wochen nach Teilnahmeschluss ermittelt.
				</p>
			</div>

			<div className="bg-greenDark px-4 py-[27px] sm:py-[9px] text-center font-SentinelBold text-[24px] text-white sm:text-[48px]">
				Hier geht's zum Gewinnspiel
			</div>
			<div
				className="js-sogehts bg-[#A3C35B] relative "
				style={{
					border: "0 solid var(--color-primary, #046A38)",
					background: "radial-gradient(50% 50% at 50% 50%, #BBDA77 0%, #A3C35B 100%)",
				}}
			>
				<svg
					aria-hidden="true"
					width="58"
					height="74"
					viewBox="0 0 58 74"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="absolute left-1/2 -translate-x-1/2 top-0 block sm:-ml-[400px] w-[24px] sm:w-[58px] h-[43px] sm:h-[74]"
				>
					<g clip-path="url(#clip0_6123_320)">
						<mask id="mask0_6123_320" maskUnits="userSpaceOnUse" x="0" y="0" width="58" height="74">
							<path
								d="M6.19118 73.7955L57.3493 69.2221L51.161 0.000244141L0.00291355 4.57365L6.19118 73.7955Z"
								fill="white"
							/>
						</mask>
						<g mask="url(#mask0_6123_320)">
							<path
								d="M19.2871 68.5885C19.0944 68.0027 19.293 67.3574 19.779 66.994L26.63 61.8098C16.7339 54.9048 9.14281 43.7574 4.52483 29.4276C0.853711 18.0466 0.381267 8.80398 0.387666 8.32964L0.420892 5.76701C0.429719 4.97864 0.983576 4.41843 1.76534 4.42853L4.46491 4.46408C5.10638 4.47442 5.66724 4.8796 5.82137 5.51188C5.88774 5.77668 12.6202 31.885 35.9294 47.165L39.1998 37.6862C39.384 37.1529 39.8684 36.7712 40.4318 36.7269C40.9952 36.6827 41.528 36.9797 41.7928 37.4851L50.1864 53.4463L57.0785 67.2836C57.1824 67.4897 57.2334 67.7189 57.2288 67.9408C57.227 68.1933 57.158 68.4456 57.0253 68.6666C56.7702 69.0894 56.3173 69.3452 55.8304 69.358L40.5844 69.5519L20.631 69.5636C20.0209 69.5628 19.4792 69.1682 19.2871 68.5885Z"
								fill="#005E34"
							/>
						</g>
					</g>
					<defs>
						<clipPath id="clip0_6123_320">
							<rect
								width="51.368"
								height="69.4979"
								fill="white"
								transform="translate(57.3522 69.2218) rotate(174.891)"
							/>
						</clipPath>
					</defs>
				</svg>

				<h2 className="h2 pt-10 sm:pt-12 pb-3 sm:pb-10">So einfach geht’s ...</h2>

				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/shop.png"} />
					<img
						src={"/images/shop-mobile.png"}
						className="mx-auto w-full max-w-[1030px] px-4 sm:px-0 block"
						alt="Drei einfache Schritte: Kaufen, hochladen und gewinnen"
					/>
				</picture>

				<NextStep />
				<div className="px-4 sm:px-0 pt-10 sm:pt-0">
					<div className="relative mx-auto block w-full max-w-[780px] border-[5px] border-dotted border-white px-[15px] sm:px-[100px] py-[36px] sm:py-[50px] text-center  -mt-2">
						<img
							src={"/images/bonsample.png"}
							alt="Beispiel eines Kassenbons"
							className="hidden sm:block absolute left-0 top-0 w-full max-w-[203px] -translate-x-1/2  -translate-y-[30px]"
							onClick={() => {
								setShowPopup(true)
							}}
						/>
						<img
							src={"/images/upload.png"}
							alt="Symbol für den Kassenbon-Upload"
							className="absolute right-0 top-0 w-full  max-w-[118px] md:max-w-[237px] -translate-y-[80%]  md:-translate-y-1/2  md:translate-x-1/2 "
						/>
						<svg
							width="65"
							height="51"
							viewBox="0 0 65 51"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							className="absolute -top-[60px] right-[110px] sm:hidden"
							aria-hidden="true"
						>
							<mask id="mask0_6254_720" maskUnits="userSpaceOnUse" x="0" y="0" width="65" height="51">
								<path
									d="M-5.41496e-06 8.88664L7.15129 50.4654L64.4702 41.941L57.3189 0.362243L-5.41496e-06 8.88664Z"
									fill="white"
								/>
							</mask>
							<g mask="url(#mask0_6254_720)">
								<path
									d="M5.19657 19.328C5.67246 19.1412 6.22356 19.2711 6.55831 19.6501L11.3282 24.9893C16.4405 16.5561 25.2409 9.79404 36.8889 5.30234C46.1397 1.73215 53.8162 0.88311 54.2121 0.864578L56.3512 0.763376C57.0092 0.7311 57.5125 1.15567 57.5551 1.79505L57.7015 4.003C57.7348 4.52775 57.4335 5.00639 56.9163 5.16402C56.6998 5.23153 35.3679 12.0412 24.1469 31.8555L32.2645 34.0534C32.7212 34.1772 33.0711 34.5539 33.1448 35.0121C33.2184 35.4703 33.0055 35.9207 32.6013 36.1624L19.8392 43.8214L8.75027 50.1469C8.5852 50.2421 8.39736 50.2952 8.21201 50.3026C8.00139 50.3138 7.78651 50.27 7.59351 50.1726C7.22435 49.9854 6.98145 49.628 6.93905 49.2308L5.78271 36.781L4.47113 20.4751C4.43202 19.9764 4.72573 19.514 5.19657 19.328Z"
									fill="#005E34"
								/>
							</g>
						</svg>

						<div className="relative z-10">
							<ReceiptUpload dispatch={dispatch} />
						</div>
					</div>
				</div>

				<button
					className="px-4 sm:px-0 text-center font-CalibriBold text-[17px] pt-5 underline text-white sm:hidden relative w-full"
					onClick={() => setShowPopup(true)}
					type="button"
				>
					<svg
						className="absolute left-6 top-0"
						width="45"
						height="48"
						viewBox="0 0 45 48"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<mask id="mask0_6254_860" maskUnits="userSpaceOnUse" x="0" y="0" width="45" height="48">
							<path
								d="M22.3713 47.4571L44.8135 31.1459L22.5345 0.242897L0.092351 16.554L22.3713 47.4571Z"
								fill="white"
							/>
						</mask>
						<g mask="url(#mask0_6254_860)">
							<path
								d="M26.9843 41.3801C26.7307 41.1575 26.6418 40.7985 26.7653 40.4927L28.4889 36.1543C21.9635 35.6393 15.3175 32.4875 9.15796 27.0136C4.26436 22.667 1.45371 18.4429 1.32368 18.2176L0.620548 17.001C0.403589 16.6271 0.503361 16.2098 0.868731 15.9983L2.13062 15.268C2.431 15.0954 2.80471 15.1311 3.05348 15.3864C3.1585 15.4928 13.6012 25.9313 28.6952 26.6808L27.5541 21.3097C27.4899 21.0074 27.6076 20.6935 27.8564 20.5168C28.1053 20.3401 28.4357 20.3325 28.7002 20.4974L37.0681 25.6952L44.1442 30.3078C44.2501 30.3762 44.338 30.4701 44.3981 30.5759C44.4681 30.6954 44.5068 30.8333 44.5072 30.9742C44.5075 31.244 44.3692 31.4899 44.147 31.6306L37.131 35.9407L27.8809 41.4677C27.5978 41.6362 27.2359 41.6001 26.9843 41.3801Z"
								fill="white"
							/>
						</g>
					</svg>
					Beispiel Kassenbon anzeigen
				</button>

				{showPopup && (
					<Popup
						close={() => {
							setShowPopup(false)
						}}
					>
						<img
							src={"/images/bonsample-nozoom.png"}
							alt="Beispiel Kassenbon"
							className="  w-full max-w-[503px] mx-auto "
						/>
					</Popup>
				)}

				<NextStep />
				<div className="px-4 sm:px-0">
					<Form />
				</div>
				<div className="sm:-mt-2">
					<NextStep />
				</div>

				<p className="text-center font-SentinelBold text-[53px] sm:text-[72px] text-white -mt-2 pb-7">
					Viel Glück.
				</p>
			</div>
		</PromoSoonOverHandler>
	)
}
export default Home
